// Facility Info phone placeholders for routing-group contact fields (ENG-3502),
// resolved to the calling location's live values at send/dial time. Emails reuse
// FACILITY_EMAIL_TOKEN / DM_EMAIL_TOKEN from ExternalReceiptTokens.
export const FACILITY_PHONE_TOKEN = "{{facility_phone}}";
export const DM_PHONE_TOKEN = "{{dm_phone}}";

// Where a single forward number comes from: typed by the operator, or Facility Info.
export type ForwardPhoneSource = "custom" | "facility" | "dm";

export function forwardPhoneSource(value: string | null | undefined): ForwardPhoneSource {
  if (value === FACILITY_PHONE_TOKEN) return "facility";
  if (value === DM_PHONE_TOKEN) return "dm";
  return "custom";
}

// The stored value for a forward number: the placeholder, or the typed number.
export function forwardPhoneValue(source: ForwardPhoneSource, custom: string): string {
  if (source === "facility") return FACILITY_PHONE_TOKEN;
  if (source === "dm") return DM_PHONE_TOKEN;
  return custom;
}

export interface SmsRecipientSelection {
  facility: boolean;
  dm: boolean;
  custom: string[];
}

// Reads the Facility / DM checkboxes and the typed numbers from a stored SMS recipient list.
export function splitSmsRecipients(entries: string[]): SmsRecipientSelection {
  return {
    facility: entries.includes(FACILITY_PHONE_TOKEN),
    dm: entries.includes(DM_PHONE_TOKEN),
    custom: entries.filter((e) => e !== FACILITY_PHONE_TOKEN && e !== DM_PHONE_TOKEN)
  };
}

// Rebuilds the stored SMS recipient list from the checkboxes and the typed numbers.
export function joinSmsRecipients(selection: SmsRecipientSelection): string[] {
  const tokens: string[] = [];
  if (selection.facility) tokens.push(FACILITY_PHONE_TOKEN);
  if (selection.dm) tokens.push(DM_PHONE_TOKEN);
  return [...tokens, ...selection.custom];
}
